import { AppThunkAction } from "../appThunkAction";
import hubService from "../../api/services/hub";
import { MeetingContent, MeetingKnownAction, Meeting } from "./types";
import graphService from "../../api/services/graph";

export const addToMeeting = (
  meetingId: string,
  fileId: number,
  storyId: number,
  category: string
): AppThunkAction<MeetingKnownAction> => async (dispatch) => {
  dispatch({
    type: "ADD_MEETING_REQUEST",
    meetingId: meetingId,
  });
  const data = await hubService.addToMeeting(meetingId, {
    items: [
      {
        fileId,
        storyId,
      },
    ],
  });
  dispatch({
    type: "ADD_MEETING_SUCCESS",
    payload: data.value,
  });
};

export const addFilesToMeeting = (
  meetingId: string,
  items: { fileId: number; storyId: number }[]
): AppThunkAction<MeetingKnownAction> => async (dispatch) => {
  dispatch({
    type: "ADD_MEETING_REQUEST",
    meetingId: meetingId,
  });
  const data = await hubService.addToMeeting(meetingId, {
    items
  });
  dispatch({
    type: "ADD_MEETING_SUCCESS",
    payload: data.value,
  });
};

export const getMeetingsContents = (
  meetingId: string
): AppThunkAction<MeetingKnownAction> => async (dispatch) => {
  dispatch({
    type: "GET_MEETING_REQUEST",
    meetingId: meetingId,
  });
  const data = await hubService.getMeetingContent(meetingId);
  dispatch({
    type: "GET_MEETING_SUCCESS",
    payload: data.value,
    message: ''
  });
    };

export const saveMeeting = (
  data: any
): AppThunkAction<MeetingKnownAction> => async (dispatch) => {
  const result = await hubService.saveMeeting(data);
  dispatch({
    type: "GET_MEETING_SUCCESS",
    payload: result.value,
    message: ''
  });
};

export const removeContent = (
  fileId: number[],
  meetingId: string
): AppThunkAction<MeetingKnownAction> => async (dispatch) => {
  dispatch({
    type: "REMOVE_MEETING_CONTENT_REQUEST",
  });
  const result = await hubService.removeContent(meetingId, fileId);
  dispatch({
    type: "GET_MEETING_SUCCESS",
    payload: result.value,
    message: 'Files successfully removed from meeting'
  });
  dispatch({
    type: 'REMOVE_MEETING_CONTENT_SUCCESS'
  })
};

export const reorderContent = (
  meetingId: string,
  newOrder: any[]
): AppThunkAction<MeetingKnownAction> => async (dispatch) => {
  const result = await hubService.reorderContent(meetingId, newOrder);
  dispatch({
    type: "GET_MEETING_SUCCESS",
    payload: result.value,
    message: ''
  });
};

export const getTeamEvent = (
  chatId: string
): AppThunkAction<MeetingKnownAction> => async (dispatch) => {
  const result = await graphService.getEvent(chatId);
  dispatch({
    type: "GET_TEAM_EVENT_SUCCESS",
    payload: result.value,
  });
    };

export const getTeamEvents = (
    scheduledDate: Date 
): AppThunkAction<MeetingKnownAction> => async (dispatch) => {
    const result = await graphService.getAllEvents(scheduledDate);
    dispatch({
        type: "GET_TEAM_EVENTS_SUCCESS",
        payload: result.value,
        scheduledDate: scheduledDate
    });
};



export const addAppToMeeting = (
    chatId: string
): AppThunkAction<MeetingKnownAction> => async () => {
    const result = await graphService.addAppToMeeting(chatId);
};


export const selectBookmark = (
  bookmarkId: number,
  items:  {
    id: number;
    storyId: number;
}[] = []
): AppThunkAction<MeetingKnownAction> => (dispatch) => {
  dispatch({
    type: "SELECT_BOOKMARK",
    bookmarkId,
    items
  });
};

export const selectBookmarkAdd = (
  bookmarkId: number,
  items:  {
    id: number;
    storyId: number;
    checked: boolean;
}[] = []
): AppThunkAction<MeetingKnownAction> => (dispatch) => {
  dispatch({
    type: "SELECT_BOOKMARK_ADD",
    bookmarkId,
    items
  });
};

export const selectRecommandationStory = (
  storyId: number,
  files: number[] = []
): AppThunkAction<MeetingKnownAction> => (dispatch) => {
  dispatch({
    type: "SELECT_RECOMMANDATION_STORY",
    storyId,
    files,
  });
};

export const updateRemoveFile = (
  fileId: number,
  action: "add" | "remove"
): AppThunkAction<MeetingKnownAction> => (dispatch) => {
  dispatch({
    type: "UPDATE_REMOVE_FILE_LIST",
    fileId,
    action,
  });
};

export const selectAllRecommendationItems = (
  flag: boolean
): AppThunkAction<MeetingKnownAction> => (dispatch) => {
  dispatch({
    type: "RECOMMENDATIONS_SELECT_ALL",
    payload: flag,
  });
};

export const selectRecommendationItem = (
  fileId: number,
  checked: boolean
): AppThunkAction<MeetingKnownAction> => (dispatch) => {
  dispatch({
    type: "RECOMMENDATIONS_SELECT_ITEM",
    checked,
    fileId,
  });
};

export const BookmarkSelectItem = (
  storyId: number,
  fileId: number,
  checked: boolean
): AppThunkAction<MeetingKnownAction> => (dispatch) => {
  dispatch({
    type: "BOOKMARK_SELECT_ITEM",
    checked,
    fileId,
    storyId,
  });
}; 

export const inMeetingSearch = (
    message: string,
    currentBookmarkSelection :number[]
): AppThunkAction<MeetingKnownAction> => (dispatch) => {
    dispatch({
        type: "FILES_ADDED_MESSAGE",
        filesAddedMessage: message,
        currentBookmarkSelection: currentBookmarkSelection
    });
    };


export const teamsTheme = (
    theme: string, 
): AppThunkAction<MeetingKnownAction> => (dispatch) => {
    dispatch({
        type: "SELECTED_THEME",
        theme: theme, 
    });
};


 
export const clearMessage = (): AppThunkAction<MeetingKnownAction> => (dispatch) => {
  dispatch({
    type: "CLEAR_MESSAGE",
  });
};

export const updateMessage = (messge:string): AppThunkAction<MeetingKnownAction> => (dispatch) => {
    dispatch({
        type: "UPDATE_MESSAGE",
        message: messge
    });
};
